module.exports = __webpack_public_path__ + "static/media/bitcoin.51cfc34f.png";